import React from 'react';
import { ClockIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { ResendLink } from '../components/auth/ResendLink';
interface ExpiredLinkProps {
  email?: string;
  onStartOver: () => void;
}

/**
 * An expired verification link. Deliberately unalarmed: no red, no "error",
 * no suggestion the person did something wrong.
 */
export function ExpiredLink({
  email = 'r.mendel@example.com',
  onStartOver
}: ExpiredLinkProps) {
  return <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-16 sm:px-6" data-id="element-897" data-mp="7hw6xj6t0dqi">
      <span className="flex h-12 w-12 items-center justify-center rounded-pill bg-canvas" data-id="element-898" data-mp="cgqvz2vd6yj2">
        <ClockIcon aria-hidden="true" className="h-5 w-5 text-ink-muted" data-id="element-899" data-mp="3tqox3je8kp77" />
      </span>

      <div className="flex flex-col gap-3" data-id="element-900" data-mp="2j2qbhw806m4">
        <h1 className="text-page-title font-semibold text-ink" data-id="element-901" data-mp="2ic1p37l4cwte">
          That link has expired.
        </h1>
        <p className="text-body text-ink-muted" data-id="element-902" data-mp="2nbebxsbzq3vz">
          Links stop working after seven days, which is the only thing that has happened here.
          Your answers are still saved and nothing has been shared with anyone.
        </p>
      </div>

      <div className="flex flex-col gap-4 rounded-card border border-rule bg-card p-5" data-id="element-903" data-mp="3f4cpeq5zegw2">
        <p className="text-body text-ink" data-id="element-904" data-mp="3t3uj9jy4wkca">
          We can send a new one to <span className="font-medium" data-id="element-905" data-mp="3o2x137d4jqas">{email}</span>.
        </p>
        <ResendLink email={email} variant="primary" data-id="element-906" data-mp="6v31j24oimjr" />
      </div>

      <div className="flex flex-col gap-3 border-t border-rule pt-5" data-id="element-907" data-mp="6ti6zcid73lw">
        <p className="text-small text-ink-muted" data-id="element-908" data-mp="1wro6hf6dtws">
          Wrong address, or that inbox is gone?
        </p>
        <div className="flex flex-wrap gap-3" data-id="element-909" data-mp="fm3axmhc75qo">
          <Button variant="secondary" data-id="element-910" data-mp="fp7qfg095nwn">Use a different email</Button>
          <Button variant="quiet" onClick={onStartOver} data-id="element-911" data-mp="bmb87qemjtt8">
            Start over
          </Button>
        </div>
        <p className="text-small text-ink-muted" data-id="element-912" data-mp="pjgd3n2lqmmw">
          Or write to the portal team and a person will answer — not a form.
        </p>
      </div>
    </div>;
}